/**
 * Faculty Emergency Contact
 */
import { z } from 'zod';
import {
  FacultyEmergencyContactId,
  FacultyId,
  UnixTimestamp,
} from '../types/branded';

export const FacultyEmergencyContactSchema = z.object({
  id: FacultyEmergencyContactId,
  facultyId: FacultyId,
  name: z.string().min(1),
  relationship: z.string().min(1),
  phone: z.string().min(7),
  alternatePhone: z.string().min(7).nullable().optional(),
  email: z.string().email().nullable().optional(),
  priority: z.number().int().min(1),
  consentProvided: z.boolean(),
  createdAt: UnixTimestamp,
  updatedAt: UnixTimestamp,
});
export type FacultyEmergencyContact = z.infer<typeof FacultyEmergencyContactSchema>;
